
export const applicationsData = [
    {
        id: "head-1",
        title: "ФИО заместителя",
        width: "180px",
    },
    {
        id: "head-2",
        title: "Должность заместителя",
        icon: "",
        width:  "150px",
    },
    {
        id: "head-3",
        title: "Полный путь до подразделения заместителя",
        icon: "",
        width:  "450px",
    },
    {
        id: "head-4",
        title: "Дата начала замещения",
        icon: "",
        width:"108px",
    },
    {
        id: "head-5",
        title: "Дата окончания замещения",
        icon: "",
        width:  "108px",
    },
    // {
    //     id: "head-6",
    //     title: "Комментарий",
    //     icon: "",
    //     width: "200px",
    // },
    {
        id: "head-6",
        title: "  ",
        icon: "",
        width: "50px",
    },
];
